import { render, staticRenderFns } from "./FormulatingFoundationsLeft.vue?vue&type=template&id=0aac7220&"
import script from "./FormulatingFoundationsLeft.vue?vue&type=script&lang=js&"
export * from "./FormulatingFoundationsLeft.vue?vue&type=script&lang=js&"
import style0 from "./FormulatingFoundationsLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCardImg, BCol, BCardText, BCardBody, BRow, BCard} from 'bootstrap-vue'
    installComponents(component, {BCardImg, BCol, BCardText, BCardBody, BRow, BCard})
    

export default component.exports